export const ErrorComponent = ({error}) => {
    return <h1>An Error Occurred: {error.errorCode}</h1>;
}